import type { LandingPageGoal } from "./api"

export function goalLabel(goal: LandingPageGoal): string {
  switch (goal) {
    case "traffic":
      return "More visitors"
    case "leads":
      return "Signups or leads"
    case "purchases":
      return "Purchases"
    case "inherit":
      return "Same as site"
    case "not_sure":
      return "Not sure"
  }
}

export function locationsLabel(value: Record<string, unknown> | null): string {
  const included = Array.isArray(value?.included) ? value.included : []
  return included.length > 0 ? included.join(", ") : "All locations"
}
